import { useEffect } from "react";

function useReloadOnBackOrForward() {
   const reloadPaths = ["/trial", "/login", "/sign-up", "/check"];

   useEffect(() => {
      const handlePopState = () => {
         const currentPath = window.location.pathname;
         if (reloadPaths.includes(currentPath)) {
            setTimeout(() => {
               window.location.reload(true);
            }, 1000);
         }
      };
      window.addEventListener("popstate", handlePopState);
      return () => {
         window.removeEventListener("popstate", handlePopState);
      };
   }, [window.location.pathname]);
}

export default useReloadOnBackOrForward;
